import React from 'react';
import { Component } from 'react';
import "./StatusPage.scss";
import StatusScreen from '../../../components/screens/Status/StatusScreen';
import { authService } from '../../../services/authService';
import routingService from '../../../services/routingService';

type StatusPageProps = {
};

type StatusPageState = {
    usrId: number;
    usrLogin: string;
};

export default class StatusPage extends Component<StatusPageProps, StatusPageState> {
    constructor(props: StatusPageProps) {
        super(props);

        if (!authService.isAuthenticated()) {
            window.location.replace(routingService.getMainPageRoute());
        }

        let basicUserData = authService.getUserData();

        this.state = {
            usrId: Number(basicUserData!.id),
            usrLogin: basicUserData!.name
        };
    }

    public render() {
        return (
            <div>
                <div className="web-container status">

                    <section id="status">
                        <StatusScreen
                            usrId={this.state.usrId}
                            usrLogin={this.state.usrLogin}
                        />
                    </section>

                </div>
            </div>
        )
    }
}